import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Placestovisit() {



    const cardData =
    {
        keyword: 'Places to Visit Nearby Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Places to Visit Nearby Morachi Chincholi Pune',
        headingDescription: 'Looking for the best places to visit nearby Morachi Chincholi Pune? This scenic rural destination is surrounded by a variety of cultural, historical, and natural attractions perfect for day trips and weekend escapes. Just a short drive from Morachi Chincholi, you can explore the ancient Bhuleshwar Temple, known for its unique architecture and panoramic hilltop views. Shivneri Fort, the birthplace of Chhatrapati Shivaji Maharaj, offers a dose of history and trekking fun. Nature enthusiasts should not miss the Nighoj Potholes, a rare geological wonder created by the Kukadi River. The sacred Ranjangaon Mahaganpati Temple, part of the Ashtavinayak circuit, is also nearby and attracts pilgrims year-round. These nearby attractions perfectly complement your visit to Morachi Chincholi, making it an ideal hub for rural tourism, spiritual journeys, and historical exploration near Pune.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Peacock Sanctuary at Morachi Chincholi",
    "description": "See hundreds of peafowls roaming freely among ancient tamarind groves. Ideal for birdwatching and photography, especially at sunrise and sunset."
  },
  {
    "title": "Lenyadri Caves (~29 km)",
    "description": "A group of serene 1st-century rock-cut Buddhist caves and one of the Ashtavinayak Ganesh shrines—perfect for spiritual exploration and heritage appreciation." 
  },
  {
    "title": "Shivneri Fort (~37 km)",
    "description": "Birthplace of Chhatrapati Shivaji Maharaj. This historic hill fort offers deep Maratha heritage, panoramic valley views, and moderate trekking trails."
  },
  {
    "title": "Bhuleshwar Temple (~46 km)",
    "description": "An 8th-century Shiva temple nestled on a hill, known for its intricate carvings, Indo-Islamic architecture, and scenic vantage points over the countryside."
  },
  {
    "title": "Takali Dhokeshwar Temple (~25 km)",
    "description": "A tranquil hilltop Shiva temple with spiritual energy and sweeping views. It’s accessible via a short climb and popular with pilgrims and sunset watchers."
  },
  {
    "title": "Tulapur – Sambhaji Maharaj Samadhi (~33 km)",
    "description": "A solemn historical site on the banks of the Bhima River, housing the samadhi of Sambhaji Maharaj—a must-visit for Maratha history enthusiasts."
  },
  {
    "title": "Pabal – Mastani Samadhi & Jain Temple (~20 km)",
    "description": "Visit the romantic Mastani Samadhi of Bajirao’s beloved and the ornate Pabal Jain temple—rich in heritage, spirituality, and Mughal-Maratha history."
  },
  {
    "title": "Ozarde Waterfall (~40 km)",
    "description": "A picturesque seasonal waterfall set amid lush greenery—perfect for a refreshing midway stop and short nature walk."
  },
  {
    "title": "Malthan Fort (~24 km)",
    "description": "A lesser-known hill fort offering peaceful treks and rewarding Sahyadri range views—great for offbeat exploration."
  },
  {
    "title": "Ranjangaon Mahaganpati (~20 km)",
    "description": "One of the Ashtavinayak Ganesh temples, known for its striking architecture and religious importance for pilgrims and day-visitors alike."
  }
],




"services": [
  {
    "name": "Top Attractions Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra is among the top rural attractions near Morachi Chincholi. With immersive farming experiences, delicious traditional meals, and serene surroundings, it offers a unique blend of nature, culture, and recreation in one day trip."
  },
  {
    "name": "Historical Places Close to Morachi Chincholi",
    "description": "Just a short drive from Anand Krushi Paryatan Kendra, you can explore historic marvels like Shivneri Fort or Bhuleshwar Temple. These sites pair beautifully with the farm’s peaceful vibe, creating a heritage-meets-nature day trip experience."
  },
  {
    "name": "Nature Parks Near Morachi Chincholi",
    "description": "While there are no formal parks in the immediate area, Anand Krushi Paryatan Kendra offers an equally enriching experience with natural green spaces, orchards, and peacock habitats—perfect for nature walks and eco-friendly exploration."
  },
  {
    "name": "Cultural Sites Nearby",
    "description": "Nearby villages and temples showcase Maharashtra’s deep cultural roots. Anand Krushi Paryatan Kendra complements this with live folk music, traditional rural décor, and Marathi-style cuisine, making it a cultural site in its own right."
  },
  {
    "name": "Family-Friendly Spots Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra is ideal for families—offering activities like bullock cart rides, animal petting, farm games, and shaded picnic spots. It’s a secure and wholesome destination for family outings and school trips alike."
  },
  {
    "name": "Adventure Parks Close to Morachi Chincholi",
    "description": "Skip the concrete theme parks—Anand Krushi Paryatan Kendra offers real-life adventure through obstacle courses, nature trails, tractor rides, and traditional village games. It’s rural adventure, reimagined."
  },
  {
    "name": "Local Markets Near Morachi Chincholi",
    "description": "Plan a visit to local village markets around Morachi Chincholi to shop for fresh produce, handicrafts, and sweets. At Anand Krushi Paryatan Kendra, you can also buy seasonal fruits, pickles, jaggery, and other farm products directly from the source."
  },
  {
    "name": "Religious Places Near Morachi Chincholi",
    "description": "Nearby temples such as Jejuri, Morgaon Ganpati Mandir, and Bhuleshwar offer spiritual excursions close to Anand Krushi Paryatan Kendra. Combine these with a farm visit for a peaceful, meaningful day trip."
  },
  {
    "name": "Scenic Viewpoints Near Morachi Chincholi",
    "description": "Though mostly flat farmland, the area around Anand Krushi Paryatan Kendra offers beautiful sunrise and sunset views across open fields and mango orchards—especially during monsoon or harvest season."
  },
  {
    "name": "Wildlife Sanctuaries Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra lies near peacock conservation areas in Morachi Chincholi. Visitors regularly spot these birds roaming freely across the farm, making it a soft wildlife experience for nature enthusiasts."
  },
  {
    "name": "Picnic Spots Near Morachi Chincholi",
    "description": "With shaded gazebos, play areas, and home-cooked meals, Anand Krushi Paryatan Kendra is a top picnic destination near Morachi Chincholi. It’s perfect for relaxing in nature with family or friends."
  },
  {
    "name": "Waterfalls Near Morachi Chincholi",
    "description": "Though the immediate region is largely agricultural, Anand Krushi Paryatan Kendra is within driving distance of seasonal waterfalls like Bhor Ghat and small hidden cascades that flow during the monsoon—perfect for pairing with a farm visit."
  },
  {
    "name": "Popular Day Trip Locations Nearby",
    "description": "Anand Krushi Paryatan Kendra is a staple on the list of best day trip destinations near Morachi Chincholi. It offers a perfect combination of fun, education, food, and nature, making it popular among families, schools, and couples alike."
  },
  {
    "name": "Eco-Tourism Spots Near Morachi Chincholi",
    "description": "Sustainably run, Anand Krushi Paryatan Kendra promotes eco-tourism by practicing organic farming, recycling water, and offering green educational programs. It’s a must-visit for eco-conscious travelers looking to support responsible tourism."
  },
  {
    "name": "Resorts Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra stands out among resorts near Morachi Chincholi thanks to its authentic farm setting, hands-on agro experiences, and focus on simplicity and nature. It’s a rural resort that feels like home away from home."
  }
],
"tableData": [
  ["Top Attractions Near Morachi Chincholi", "- Historical Places Close to Morachi Chincholi"],
  ["Nature Parks Near Morachi Chincholi", "- Cultural Sites Nearby"],
  ["Family-Friendly Spots Near Morachi Chincholi", "- Adventure Parks Close to Morachi Chincholi"],
  ["Local Markets Near Morachi Chincholi", "- Religious Places Near Morachi Chincholi"],
  ["Scenic Viewpoints Near Morachi Chincholi", "- Wildlife Sanctuaries Near Morachi Chincholi"],
  ["Picnic Spots Near Morachi Chincholi", "- Waterfalls Near Morachi Chincholi"],
  ["Popular Day Trip Locations Nearby", "- Eco-Tourism Spots Near Morachi Chincholi"],
  ["Resorts Near Morachi Chincholi", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Shirur Fort",
    "WhyChoosedescription": "A historic fort located about 20 km from Morachi Chincholi, Shirur Fort offers scenic views and a glimpse into the region’s past. It’s an excellent spot for history enthusiasts and nature lovers."
  },
  {
    "WhyChooseheading": "Nighoj Caves",
    "WhyChoosedescription": "Known for its unique natural potholes formed by river erosion, Nighoj Caves are around 25 km from Morachi Chincholi. The nearby Jain Temple adds spiritual value to this geological wonder."
  },
  {
    "WhyChooseheading": "Ramling Mandir",
    "WhyChoosedescription": "Situated about 30 km away, Ramling Mandir is a serene Hindu temple dedicated to Lord Shiva. It’s a peaceful place for devotees and tourists alike."
  },
  {
    "WhyChooseheading": "Mallikarjun Temple",
    "WhyChoosedescription": "Located roughly 35 km from Morachi Chincholi, Mallikarjun Temple is an important religious site with beautiful architecture and tranquil surroundings."
  },
  {
    "WhyChooseheading": "Vadgaon Dam",
    "WhyChoosedescription": "A quiet dam near Shirur, Vadgaon Dam is ideal for picnics and enjoying the natural beauty of the area. It’s a perfect spot to unwind amidst greenery."
  },
  {
    "WhyChooseheading": "Loni Kalbhor",
    "WhyChoosedescription": "About 40 km away, Loni Kalbhor offers rural charm and local culture. Visitors can experience traditional village life and peaceful countryside views."
  }
]







    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What are the must-visit places near Morachi Chincholi?',
    answer: 'Must-visit places include Anand Krushi Paryatan Kendra, Ranjangaon Ganpati Temple, Alandi Temple, Shikrapur village, and the peacock sanctuary itself.',
  },
  {
    id: 'FAQ2',
    question: 'How far is Ranjangaon Ganpati Temple from Morachi Chincholi?',
    answer: 'Ranjangaon Ganpati Temple is about 25 km from Morachi Chincholi, roughly a 30-minute drive.',
  },
  {
    id: 'FAQ3',
    question: 'What can I do at Anand Krushi Paryatan Kendra?',
    answer: 'You can enjoy pony rides, tractor rides, butterfly watching, nature walks, birdwatching, and farm-based activities perfect for families and groups.',
  },
  {
    id: 'FAQ4',
    question: 'Is Alandi Temple close by?',
    answer: 'Yes, Alandi Temple is around 30 km from Morachi Chincholi and is a significant pilgrimage site dedicated to Sant Dnyaneshwar.',
  },
  {
    id: 'FAQ5',
    question: 'Are there any cultural or historical sites nearby?',
    answer: 'Besides temples, nearby villages like Shikrapur offer a glimpse into rural Maharashtra’s culture and lifestyle.',
  },
  {
    id: 'FAQ6',
    question: 'Can I visit the peacock sanctuary in Morachi Chincholi?',
    answer: 'Yes, Morachi Chincholi is famous for its peacock population, especially during monsoon and post-monsoon seasons.',
  },
  {
    id: 'FAQ7',
    question: 'What facilities are available at these nearby places?',
    answer: 'Facilities vary but generally include parking, restrooms, refreshment stalls, and guided tours at larger sites like Anand Krushi and Ranjangaon Temple.',
  },
  {
    id: 'FAQ8',
    question: 'Is it suitable for a family day outing?',
    answer: 'Definitely! The combination of nature, culture, and activities makes these places ideal for families with kids and elders.',
  },
  {
    id: 'FAQ9',
    question: 'What is the best time to visit these places?',
    answer: 'The best time is from June to November when the weather is pleasant and peacocks are active.',
  },
  {
    id: 'FAQ10',
    question: 'How can I plan my visit to cover multiple nearby places?',
    answer: 'You can plan a route starting from Morachi Chincholi, then visiting Anand Krushi, Ranjangaon Temple, and Alandi in a day or two, depending on your pace.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prakash Joshi, Pune',
    feedback: "We had a wonderful day exploring Morachi Chincholi and nearby places. The peaceful farm visit at Anand Krushi was refreshing, and the spiritual vibe at Ranjangaon Ganpati was uplifting.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shweta Deshmukh, Pune',
    feedback: "Our family trip covered Morachi Chincholi’s peacock sanctuary, Alandi Temple, and some local villages. The experience was serene and educational for kids.",
    rating: 4,
  },
];







    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Places to Visit Nearby Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/places-to-visit-nearby-morachi-chincholi.jpg",
  "description": "Explore the best places to visit nearby Morachi Chincholi in Pune including nature parks, historical landmarks, temples, waterfalls, eco-tourism resorts, and scenic picnic spots. Enjoy your stay with Anand Krushi Paryatan Kendra.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1835"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "550",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/places-to-visit-nearby-morachi-chincholi"
  }
};



    return (
        <div>
<Helmet>
  <title>Places to Visit Nearby Morachi Chincholi Pune | Nature, Heritage & Family Spots | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Discover the top places to visit near Morachi Chincholi Pune – from nature and cultural sites to waterfalls, temples, wildlife parks, and scenic viewpoints. Stay at Anand Krushi Paryatan Kendra for a complete village retreat." 
  />
  <meta 
    name="keywords" 
    content="Top attractions near Morachi Chincholi, Historical places close to Morachi Chincholi, Nature parks near Morachi Chincholi, Cultural sites nearby, Family-friendly spots near Morachi Chincholi, Adventure parks close to Morachi Chincholi, Local markets near Morachi Chincholi, Religious places near Morachi Chincholi, Scenic viewpoints near Morachi Chincholi, Wildlife sanctuaries near Morachi Chincholi, Picnic spots near Morachi Chincholi, Waterfalls near Morachi Chincholi, Popular day trip locations nearby, Eco-tourism spots near Morachi Chincholi, Resorts near Morachi Chincholi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/6.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Placestovisit;